import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import HamHeader from '../../../Fireboard/components/Header/HamburgerHeader';
import styles from './move.module.scss';
import { getObjectValue } from '@utility/utills';
import SlotHeader from '../CubbySlot/SlotHeader/index';
import SlotContent from '../CubbySlot/SlotContent/index';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const MovePopup = props => {
  const { twoDimensionSlot, setPopup, onMoveSlotOrder } = props;
  const [rowArray, setRowArray] = useState([]);
  const [columnArray, setColumnArray] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState(new Map());

  const storeInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('auth'), false)
  );
  const { storeCubby } = storeInfo || {};
  const { rowCount, columnCount } = storeCubby || {};

  const isRowScrolling = rowCount > 6;
  const isColumnScrolling = columnCount > 10;

  const isSlotAvailable = () => {
    const { slots } = storeCubby || {};
    if (slots && Array.isArray(slots) && slots.length > 0) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    setRowArray(
      Array.from({ length: rowCount }, (_, rowIndex) => ({
        id: `row-${rowIndex}`,
      }))
    );
    setColumnArray(
      Array.from({ length: columnCount }, (_, colIndex) => ({
        id: `col-${colIndex}`,
      }))
    );
  }, [rowCount, columnCount]);

  const onAction = () => {
    onMoveSlotOrder(selectedSlots);
  };

  const onSelectSlot = slot => {
    const mapObj = new Map();
    mapObj.set(slot.id, slot);
    setSelectedSlots(mapObj);
  };
  const renderBody = () => {
    return (
      <div
        className={cn(
          'w-100 h-100',
          styles.cubbySlotWrapper,
          isColumnScrolling && 'overflowX',
          isRowScrolling && 'overflowY'
        )}
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
          gridTemplateRows: `repeat(${rowCount}, 1fr)`,
          gap: '8px',
          width: '100%',
          height: '90%',
        }}
      >
        {rowArray.flatMap((_, rowIndex) =>
          columnArray.map((_, colIndex) => {
            const slot = twoDimensionSlot[rowIndex][colIndex];
            const check = slot?.checkData || {};
            const occupied =
              check &&
              Object.keys(check).length !== 0 &&
              check.constructor === Object;
            return (
              <div
                key={colIndex.id}
                className={cn(
                  'text-left',
                  styles.slotContainer,
                  selectedSlots.has(slot?.id) &&
                    !occupied &&
                    styles.selectedSlot
                )}
                onClick={() => !occupied && onSelectSlot(slot)}
              >
                <SlotHeader
                  occupied={occupied}
                  slot={slot}
                  selectedSlots={selectedSlots}
                />
                {occupied && (
                  <SlotContent
                    check={check}
                    moveContent={true}
                    showDeliveryVendor={false}
                    showMarketplaceVendor={false}
                  />
                )}
              </div>
            );
          })
        )}
      </div>
    );
  };

  return (
    <div className="p-3 h-100">
      <div className="mb-3">
        <HamHeader
          label={FLABEL().HEADER_MOVESLOT}
          onClickback={() => setPopup(null)}
        />
      </div>

      <div className={cn('w-100 p-2', styles.cubbySlotContainer)}>
        <div className={cn('w-100 h-92 p-2', styles.slotWrapper)}>
          {isSlotAvailable() ? (
            renderBody()
          ) : (
            <div className={styles.noCubbyText}>No cubby found!</div>
          )}
        </div>
        <div
          className={cn(
            'h-8 d-flex justify-content-center align-items-end pb-1'
          )}
        >
          <button
            disabled={selectedSlots.size === 0}
            className={cn(
              styles.primaryBtn,
              selectedSlots.size === 0 && styles.disabledbtn
            )}
            onClick={onAction}
          >
            <span>{FLABEL().CHECK_MOVE}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MovePopup;
